import { type ReactNode, useState } from 'react';

import { 
  FillButton,
  Modal, 
  ModalActions, 
  ModalContent, 
  ModalToolbar, 
  OutlineButton
} from '@recargas-dominicanas/core/components';

import { type Style, mergeStyle } from './confirm-modal.module.css';

interface Props {
  open: boolean;
  title: string;
  description?: string;
  style?: Style;
  children?: ReactNode;
  confirmButtonText?: string;
  autoClose?: boolean;
  disableButtons?: boolean;
  disableConfirmation?: boolean;
  onConfirm: () => void;
  onClose: () => void;
}

export function ConfirmModal(props: Props) {

  const {
    open,
    title,
    description,
    disableConfirmation,
    disableButtons,
    autoClose = true,
    children,
    confirmButtonText,
    style: customStyle,
    onConfirm,
    onClose
  } = props;

  const style = mergeStyle(customStyle);
  const [check, setCheck] = useState(disableConfirmation);

  async function handleConfirm() {
    onConfirm();
    if (autoClose) {
      handleClose();
    }
  }

  function handleClose() {
    setCheck(disableConfirmation);
    onClose();
  }

  style.modal = { card: `${style.modal.card} ${customStyle?.card}` };

  return (
    <Modal 
      open={open}
      style={style.modal}
      onClose={handleClose}>
      <ModalToolbar 
        title={title}
        style={style.toolbar}
        onClose={handleClose}/>
      <ModalContent>
        <div className={style.content}>
          {children}
        </div>
        {!disableConfirmation &&
          <label className={style.label}>
            <input
              type='checkbox' 
              checked={check}
              className={style.checkbox}
              onChange={() => setCheck(check => !check)}/>
            {description}
          </label>
        }
      </ModalContent>
      <ModalActions>
        <OutlineButton 
          text='Cancelar'
          disabled={disableButtons}
          onClick={handleClose}/>
        <FillButton 
          text={confirmButtonText || 'Aceptar'} 
          disabled={!check || disableButtons}
          onClick={handleConfirm}/>
      </ModalActions>
    </Modal>
  );
}
